import type { Logger } from "@expert/logging";

import { getSalesApiClient } from "@/sales-tools/home-product/api/api";
export interface GetAgentLocationResult {
    locationId?: string;
}

export const getAgentLocation = async (logger: Logger): Promise<GetAgentLocationResult> => {
    const response = await getSalesApiClient().get("v1/org-chart/expert-location");
    const data = await response.json<GetAgentLocationResult>();
    if (!data.locationId) {
        logger.warn("Expert location not found");
    }
    return data;
};
